import { createSlice } from '@reduxjs/toolkit';
// Slice dla aktywnej zakładki w użytkownikach
const statsSlice = createSlice({
  name: 'stats', // Nazwa slice'a
  initialState: {
    // checkedItems: [], // Lista zaznaczonych checkboxów
    activeTab: 'Ogólne', // Domyślna aktywna zakładka
    activeChart: 'Aktywność użytkowników',
    eventsListStartIndex: 0,
    selectedEventId: 0,

  },
  reducers: {

      toggleActiveTab: (state, action) => {
          state.activeTab = action.payload;
      },
      toggleActiveChart: (state, action) => {
          state.activeChart = action.payload;
      },
      setEventsListStartIndex: (state, action) => {
          state.eventsListStartIndex = action.payload;
      },
      setSelectedEvent: (state, action) => {
          state.selectedEventId = action.payload;
      },
      toggleSelectedEvent: (state, action) => {
          // Jeśli kliknięto ten sam event co wybrany - odznacz go
          if (state.selectedEventId === action.payload) {
              state.selectedEventId = null;
          } else {
              // W przeciwnym razie ustaw nowy wybrany event
              state.selectedEventId = action.payload;
          }
      },

    }
});

export const {
    toggleActiveTab,
    toggleActiveChart,
    setEventsListStartIndex,
    setSelectedEvent,
    toggleSelectedEvent ,
} = statsSlice.actions; // Eksport akcji
export default statsSlice.reducer;
